import React, { Component } from "react"
import onClickOutside from "react-onclickoutside"

import "./ExplainerPopup.scss"

class ExplainerPopup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      rect: {},
    }
    this.togglePopup = this.togglePopup.bind(this)
    this.popup = React.createRef()
  }

  togglePopup() {
    const rect = this.popup.current.getBoundingClientRect()
    this.setState({
      open: !this.state.open,
      rect,
    })
  }

  getPosition(rect) {
    const popupWidth = 288 //declared in CSS
    let left = "50%"
    let right = "auto"
    if (typeof window === `undefined`) return { left, right }
    if (rect.left + rect.width / 2 < popupWidth / 2) {
      left = -rect.left + 16 + popupWidth / 2 + "px"
    } else if (
      rect.right - rect.width / 2 + popupWidth / 2 >
      window.innerWidth
    ) {
      left = "auto"
      right = -popupWidth / 2 - (window.innerWidth - rect.right) + 16 + "px"
    }
    return { left, right }
  }

  setBottomUpStyle(bottomUp) {
    if (bottomUp) {
      return { top: "auto", bottom: "25px" }
    } else return {}
  }

  handleClickOutside(e) {
    this.setState({
      open: false,
    })
  }

  render() {
    const { trigger, children, bottomUp } = this.props
    const { open, rect } = this.state
    return (
      <span className="ExplainerPopup" ref={this.popup}>
        {trigger === "link" && (
          <button onClick={this.togglePopup} className="explainer-link-trigger">
            what does this mean?
          </button>
        )}
        {trigger === "icon" && (
          <button
            aria-label="what does this mean?"
            onClick={this.togglePopup}
            className="explainer-question-trigger"
          >
            ?
          </button>
        )}
        <span aria-live="polite" aria-atomic="true">
          <span
            className={`explainer-popup ${open ? "-visible" : ""}`}
            style={{
              ...this.getPosition(rect),
              ...this.setBottomUpStyle(bottomUp),
            }}
          >
            {children}
          </span>
        </span>
      </span>
    )
  }
}

export default onClickOutside(ExplainerPopup)
